/**
 * 【KYMW1400】コマ詰めVO
 *
 * @export ShiftKomaModel
 * @class ShiftKomaModel
 */
export class ShiftKomaModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * ページ番号
   */
  public pageNum = String('');

  /**
   * コマＩＤ(入替元)
   */
  public komaIDFr = Number(0);

  /**
   * コマＩＤ(入替先)
   */
  public komaIDTo = Number(0);

  /**
   * コマ・幅
   */
  public sizeW = Number(0);

  /**
   * コマ・高さ
   */
  public sizeH = Number(0);
}
